"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const path_1 = require("./path");
const cloneDeep_1 = __importDefault(require("./cloneDeep"));
const Trie_1 = require("./Trie");
function shallowClone(x) {
    if (!x || typeof x !== 'object')
        return x;
    if (Array.isArray(x))
        return Array.from(x);
    return { ...x };
}
function applyPatches(src, patches, options) {
    var _a, _b, _c;
    const onFinish = options && options.onFinish;
    if (patches.length === 0) {
        if (typeof onFinish === 'function')
            onFinish({ result: src });
        return src;
    }
    const mutated = new Trie_1.TrieNode();
    mutated.value = shallowClone(src);
    const freeze = !!((_a = options === null || options === void 0 ? void 0 : options.freeze) !== null && _a !== void 0 ? _a : true);
    const processValue = ((_b = options === null || options === void 0 ? void 0 : options.clone) !== null && _b !== void 0 ? _b : true)
        ? val => (0, cloneDeep_1.default)(val, { freeze })
        : x => x;
    /**
     * @param path 必须指向一个 array / object
     */
    const getMutateNodeAt = (path) => {
        const parts = (0, path_1.toPathParts)(path);
        let head = mutated;
        for (let i = 0; i < parts.length; i++) {
            const key = parts[i];
            const nextHead = head.getNodeAt([key], true);
            if (typeof nextHead.value === 'undefined') {
                const newChildValue = shallowClone(head.value[key]);
                head.value[key] = newChildValue;
                nextHead.value = newChildValue;
            }
            head = nextHead;
        }
        return head;
    };
    for (let i = 0; i < patches.length; i++) {
        const patch = patches[i];
        const mutateNode = getMutateNodeAt(patch.path);
        switch (patch.op) {
            case 'delete': {
                const { key, parent: parentNode } = mutateNode;
                if (!parentNode) {
                    // 对根节点操作
                    throw new Error('Cannot apply patch: impossible to delete root node.');
                }
                if (Array.isArray(parentNode.value)) {
                    // 对数组操作
                    throw new Error('Cannot apply patch: Path points to an array element.');
                }
                parentNode.deleteChild(key);
                delete parentNode.value[key];
                break;
            }
            case 'set': {
                const { key, parent: parentNode } = mutateNode;
                const newValue = processValue(patch.value);
                mutateNode.clearChildren(); // 当前字段，所有的子节点都被洗掉
                mutateNode.value = newValue;
                // 如果不是对根节点做操作，那么要回写到父级
                if (parentNode)
                    parentNode.value[key] = newValue;
                break;
            }
            case 'resortArray': {
                const oldArray = mutateNode.value;
                const newArray = new Array(patch.indexMap.length);
                const oldNodeChildren = mutateNode.children;
                const newNodeChildren = {};
                for (let ni = 0; ni < patch.indexMap.length; ni++) {
                    const oi = patch.indexMap[ni];
                    if (oi === -1)
                        continue; // 不复用
                    newArray[ni] = oldArray[oi];
                    const oldChildNode = oldNodeChildren === null || oldNodeChildren === void 0 ? void 0 : oldNodeChildren[oi];
                    if (oldChildNode) {
                        oldChildNode.setKey(String(ni));
                        newNodeChildren[ni] = oldChildNode;
                    }
                }
                mutateNode.value = newArray;
                mutateNode.children = newNodeChildren;
                const { key, parent: parentNode } = mutateNode;
                if (parentNode)
                    parentNode.value[key] = newArray;
                break;
            }
            case 'spliceArray': {
                const oldArray = mutateNode.value;
                const newArray = Array.from(oldArray);
                const { start, items } = patch;
                const deleteCount = Math.max(0, Math.min((_c = patch.deleteCount) !== null && _c !== void 0 ? _c : Infinity, newArray.length - start));
                const dIndexSinceStart = items ? items.length - deleteCount : -deleteCount;
                if (items)
                    newArray.splice(patch.start, deleteCount, ...processValue(patch.items));
                else
                    newArray.splice(patch.start, deleteCount);
                // 为了保障 mutateNode 的 children 不被污染，需要做修复
                for (let i = 0; i < deleteCount; i++)
                    mutateNode.deleteChild(String(start + i));
                for (let i = oldArray.length - 1; i >= start; i--) {
                    const oldItemNode = mutateNode.getNodeAt([String(i)]);
                    if (!oldItemNode)
                        continue;
                    const newIndex = i + dIndexSinceStart;
                    if (newIndex >= newArray.length)
                        mutateNode.deleteChild(oldItemNode.key);
                    else
                        oldItemNode.setKey(String(newIndex));
                }
                // 最后是回填
                mutateNode.value = newArray;
                const { key, parent: parentNode } = mutateNode;
                if (parentNode)
                    parentNode.value[key] = newArray;
                break;
            }
        }
    }
    const result = mutated.value;
    if (freeze) {
        mutated.forEachDFS((node) => {
            // eslint-disable-next-line no-param-reassign
            node.value = Object.freeze(node.value);
        });
    }
    if (typeof onFinish === 'function')
        onFinish({ mutated, result });
    return result;
}
exports.default = applyPatches;
